import type { EventName } from "@lit/react";
import { NumberField as NumberFieldElement, type NumberFieldEventMap as _NumberFieldEventMap, } from "@vaadin/number-field/vaadin-number-field.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { NumberFieldElement, };
export type NumberFieldEventMap = Readonly<{
    onChange: EventName<_NumberFieldEventMap["change"]>;
    onInput: EventName<_NumberFieldEventMap["input"]>;
    onInvalidChanged: EventName<_NumberFieldEventMap["invalid-changed"]>;
    onValidated: EventName<_NumberFieldEventMap["validated"]>;
    onValueChanged: EventName<_NumberFieldEventMap["value-changed"]>;
}>;
const events = { onChange: "change", onInput: "input", onInvalidChanged: "invalid-changed", onValidated: "validated", onValueChanged: "value-changed" } as NumberFieldEventMap;
export type NumberFieldProps = WebComponentProps<NumberFieldElement, NumberFieldEventMap>;
export const NumberField = createComponent({
    elementClass: NumberFieldElement, events, react: React, tagName: "vaadin-number-field"
});
